import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Nav, Tab, OverlayTrigger, Form, Tooltip, Button, Modal } from 'react-bootstrap'
import Card from '../Card'
import CustomToggle from '../dropdowns'
import { Link, useNavigate, Route } from 'react-router-dom'
import { apiHandler } from '../../api/apihandler';
import { handleImageUpload } from "../../api/uploads";
import { FEED_MEDIA_POST, FEED_POST } from "../../api/constants";
import Moment from 'moment';
import Swal from 'sweetalert2'
import EmojiPicker from 'emoji-picker-react';
//import VideoThumbnail from 'react-video-thumbnail';
import { VideoThumbnailGenerator } from 'browser-video-thumbnail-generator';
import LoaderModal from '../loaderModal'
import TagFriendSelector from './TagFriendSelector'
import AIContentCreatorModal from '../ai/AIContentCreatorModal';
import './tagFriend.css'
import './createPostModal.css'

import cross from '../../assets/images/icon/cross.png'
import small07 from '../../assets/images/small/07.png'
import small08 from '../../assets/images/small/08.png'
import small09 from '../../assets/images/small/09.png'
import small4 from '../../assets/images/small/10.png'
import small5 from '../../assets/images/small/11.png'
import small6 from '../../assets/images/small/12.png'
import small7 from '../../assets/images/small/13.png'
import small8 from '../../assets/images/small/14.png'
import playButton from '../../assets/images/icon/play_button.png'

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';
// import state selectors
import { setIsOptimizing } from '../../store/setting/actions'

const CreatePostModal = ({ postType, refreshApi, createPostModalShow, setCreatePostModalShow, eventId }) => {
   const dispatch = useDispatch()
   let profileData = (useSelector((state) => state.setting.setting.user_data))
   profileData = profileData ? JSON.parse(profileData) : "";
   let generalSettingsData = (useSelector((state) => state.setting.setting.general_settings))
   generalSettingsData = generalSettingsData ? JSON.parse(generalSettingsData) : "";

   // Keep optimization flag reset after successful publish.
   const [showLoader, setShowLoader] = useState(false);
   const [loaderText, setLoaderText] = useState("");
   const [challengeExpireDate, setChallengeExpireDate] = useState("");
   const [postContent, setPostContent] = useState('');
   const [imageFileArray, setImageFileArray] = useState([]);
   const [imageArray, setImageArray] = useState([]);
   const [videoFileArray, setVideoFileArray] = useState([]);
   //const [videoArray, setVideoArray] = useState([]);
   const [videoThumbFileArray, setVideoThumbFileArray] = useState([]);
   const [videoThumbArray, setVideoThumbArray] = useState([]);
   const [showPicker, setShowPicker] = useState(false);
   // const post_modal_show = useSelector((state) => state.setting.setting.post_modal_show);
   // const create_post_type = useSelector((state) => state.setting.setting.create_post_type);
   const [isButtonDisable, setIsButtonDisable] = useState(true);
   
   // Tag Friend States
   const [showTagFriendModal, setShowTagFriendModal] = useState(false);
   const [taggedFriends, setTaggedFriends] = useState([]);
   const [showAIContentModal, setShowAIContentModal] = useState(false);

   // console.log("postType1", create_post_type)
   // console.log("postType1", postType)

   const handleClose = () => {
      setCreatePostModalShow(false)
      //setShow(false);
      setImageArray([]);
      setImageFileArray([])
      //setVideoArray([]);
      setVideoFileArray([])
      setVideoThumbArray([])
      setVideoThumbFileArray([])
      setPostContent("")
      setChallengeExpireDate("")
      setTaggedFriends([])
      setShowAIContentModal(false)
      // dispatch(setPostModalShow(false))
   }

   // const handleShow = () => {
   //    setImageArray([]);
   //    setImageFileArray([])
   //    //setVideoArray([]);
   //    setVideoFileArray([])
   //    setVideoThumbArray([])
   //    setVideoThumbFileArray([])
   //    setPostContent("")
   //    setChallengeExpireDate("")
   //    dispatch(setCreatePostType(postType))
   //    dispatch(setPostModalShow(true))
   // }

   const deleteVideo = (index) => {
      videoThumbArray.splice(index, 1)
      videoThumbFileArray.splice(index, 1)
      videoFileArray.splice(index, 1)
   }

   const handleImageChange = async (event) => {
      const files = Array.from(event.target.files || []);
      if (!files.length) return;

      const previews = await Promise.all(
         files.map((file) =>
            new Promise((resolve) => {
               const reader = new FileReader();
               reader.onloadend = () => resolve(reader.result);
               reader.readAsDataURL(file);
            })
         )
      );

      setImageFileArray((prev) => [...prev, ...files]);
      setImageArray((prev) => [...prev, ...previews]);

      // Allow selecting the same file again by resetting the input value.
      event.target.value = "";
   };

   const handleVideoChange = (event) => {
      setShowLoader(true)
      const file = event.target.files[0];
      if (file) {
         const reader = new FileReader();
         reader.onloadend = async () => {
            await handleGenerateThumbnail(reader.result)
            setVideoFileArray([...videoFileArray, file])
            //setVideoArray([...videoArray, reader.result])
         };
         reader.readAsDataURL(file);
      }
   };

   async function handleGenerateThumbnail(videoUrl) {
      try {
         // const generator = new VideoThumbnailGenerator(videoUrl);
         // generator.getThumbnail()
         //    .then((thumbnail) => {
         //       fetch(thumbnail?.thumbnail)
         //          .then((res) => res.blob())
         //          .then((blob) => {
         //             const file = new File([blob], `${+new Date()}.jpg`, { type: 'image/jpeg' });
         //             setVideoThumbFileArray([...videoThumbFileArray, file])
         //             setVideoThumbArray([...videoThumbArray, thumbnail?.thumbnail])
         //             setShowLoader(false)
         //          })
         //          .catch((error) => {
         //             setShowLoader(false)
         //          });
         //    });
         const generator = new VideoThumbnailGenerator(videoUrl);
         generator.getThumbnail()
            .then((thumbnail) => {
               fetch(thumbnail?.thumbnail)
                  .then((res) => res.blob())
                  .then((blob) => {
                     const img = new Image();
                     img.src = URL.createObjectURL(blob);
                     img.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = 500;
                        canvas.height = 300;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, 500, 300);

                        canvas.toBlob((resizedBlob) => {
                           const file = new File([resizedBlob], `${+new Date()}.jpg`, { type: 'image/jpeg' });
                           setVideoThumbFileArray([...videoThumbFileArray, file]);
                           setVideoThumbArray([...videoThumbArray, URL.createObjectURL(resizedBlob)]);
                           setShowLoader(false);
                        }, 'image/jpeg');
                     };
                  })
                  .catch((error) => {
                     setShowLoader(false);
                     console.error('Error fetching or resizing image:', error);
                  });
            });
      } catch (error) {
         setShowLoader(false)
         Swal.fire({
            title: 'Error',
            text: "This video file is not support",
            icon: 'error',
            confirmButtonText: 'Okay'
         })
      }
   };

   useEffect(() => {

   }, [])

   function handlePostSubmit() {
      if (postContent != "" || imageArray.length > 0 || videoThumbArray.length > 0) {
         if (postType === "2" || postType === 2 || postType === "3" || postType === 3) {
            if (challengeExpireDate != "") {
               var isCmplt = 0
               if (imageArray.length > 0 || videoThumbArray.length > 0) {
                  isCmplt = 0
               } else {
                  isCmplt = 1
               }
               setShowLoader(true)
               getFeedPost(isCmplt)
            } else {
               Swal.fire({
                  title: 'Warning!',
                  text: 'Please select challenge expire date!',
                  icon: 'warning',
                  confirmButtonText: 'Okay'
               })
            }
         } else {
            var isCmplt = 0
            if (imageArray.length > 0 || videoThumbArray.length > 0) {
               isCmplt = 0
            } else {
               isCmplt = 1
            }
            setShowLoader(true)
            getFeedPost(isCmplt)
         }
      } else {
         Swal.fire({
            title: 'Warning!',
            text: 'Please enter post content or select post file!',
            icon: 'warning',
            confirmButtonText: 'Okay'
         })
      }
   };

   async function getFeedPost(isCmplt) {
      try {
         // Prepare feed_user_tags array with user IDs
         const feedUserTags = taggedFriends.map(friend => friend.id);
         
         const res = await apiHandler(FEED_POST, "POST", (postType === "7" || postType === 7) ? {
            content: postContent,
            type: postType,
            is_completed: isCmplt,
            expire_at: challengeExpireDate,
            class_id: eventId,
            feed_user_tags: feedUserTags
         } : {
            content: postContent,
            type: postType,
            is_completed: isCmplt,
            expire_at: challengeExpireDate,
            event_id: eventId,
            feed_user_tags: feedUserTags
         })
         if (res.data?.response?.status === 200) {
            if (isCmplt === 1) {
               refreshApi()
               handleClose()
               setShowLoader(false)
               Swal.fire({
                  title: 'Success',
                  text: 'Your post created successfully',
                  icon: 'success',
                  confirmButtonText: 'Okay'
               })
            } else {
               //setPostId(res?.data?.data?.feed?.id)
               handleFeedPostSubmit(res?.data?.data?.feed?.id)
            }
         } else {
            Swal.fire({
               title: 'Error',
               text: res?.response?.data?.data?.message,
               icon: 'error',
               confirmButtonText: 'Okay'
            })
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
      }
      finally {
      }
   }

   async function handleFeedPostSubmit(post_id) {
      if (imageFileArray.length > 0) {
         for (let elm of imageFileArray) {
            const url = await handleImageUpload(elm,
               `${postType === "2" || postType === 2 || postType === "3" || postType === 3 || postType === "4" || postType === 4 ?
                  "feedImages/" : "feedImages/"}`, "image/jpeg")
            //console.log("uploaded", url)
            getFeedMediaPost(url, "", "0", post_id)
         }
      }
      if (videoFileArray.length > 0) {
         //for (let elm of videoFileArray) {
         for (let i = 0; i < videoFileArray?.length; i++) {
            const url = await handleImageUpload(videoFileArray[i], 
               `${postType === "2" || postType === 2 || postType === "3" || postType === 3 || postType === "4" || postType === 4 ?
                  "feedVideos/":"feedVideos/"}`, "video/*")
            const thumb = await handleImageUpload(videoThumbFileArray[i], `feedVideosThumb/`, "image/jpeg")
            //console.log("uploaded", url)
            getFeedMediaPost(url, thumb, "1", post_id)
         }
      }
      getFeedFinalPost(post_id)
   };

   async function getFeedFinalPost(post_id) {
      try {
         // Prepare feed_user_tags array with user IDs
         const feedUserTags = taggedFriends.map(friend => friend.id);
         
         const res = await apiHandler(FEED_POST, "POST", (postType === "7" || postType === 7) ? {
            content: postContent,
            type: postType,
            is_completed: "1",
            expire_at: challengeExpireDate,
            post_id: post_id,
            class_id: eventId,
            feed_user_tags: feedUserTags
         } : {
            content: postContent,
            type: postType,
            is_completed: "1",
            expire_at: challengeExpireDate,
            post_id: post_id,
            event_id: eventId,
            feed_user_tags: feedUserTags
         })
         if (res.data?.response?.status === 200) {
            setShowLoader(false)
            setLoaderText("")
            refreshApi()
            handleClose()
            Swal.fire({
               title: 'Success',
               text: 'Your post created successfully',
               icon: 'success',
               confirmButtonText: 'Okay'
            })
            dispatch(setIsOptimizing(false));
         } else {
            Swal.fire({
               title: 'Error',
               text: res?.response?.data?.data?.message,
               icon: 'error',
               confirmButtonText: 'Okay'
            })
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
      } finally {
      }
   }

   async function getFeedMediaPost(awsPath, awsThumb, mediaType, post_id) {
      try {
         const res = await apiHandler(FEED_MEDIA_POST, "POST", {
            post_id: post_id,
            path: awsPath,
            media_type: mediaType,
            thumb: awsThumb
         })
         if (res.data?.response?.status === 200) {
            // setShow(false)
            // Swal.fire({
            //    title: 'Success',
            //    text: 'Your post created successfully',
            //    icon: 'success',
            //    confirmButtonText: 'Okay'
            // })
         } else {
            Swal.fire({
               title: 'Error',
               text: res?.response?.data?.data?.message,
               icon: 'error',
               confirmButtonText: 'Okay'
            })
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
      }
      finally {
      }
   }

   const postLabel = postType === "1" || postType === 1 ? "Stories" :
      postType === "2" || postType === 2 ? "a Challenge" :
         postType === "3" || postType === 3 ? "a Challenge" :
            postType === "4" || postType === 4 ? "Sponsor Challenge" :
               postType === "5" || postType === 5 ? `${generalSettingsData?.event_heading_text || "Event"} Post` :
                  postType === "6" || postType === 6 ? "Announcement Post" : "a Post";

   return (
      <>
         <LoaderModal showLoader={showLoader} loaderData={loaderText} />
         {/* <Card id="post-modal-data" >
            <div className="card-header d-flex justify-content-between">
               <div className="header-title">
                  <h4 className="card-title">Create
                     {postType === "2" || postType === 2 ? " a Challenge" :
                        postType === "3" || postType === 3 ? " a Challenge" :
                           postType === "4" || postType === 4 ? " Sponsor Challenge" :
                              postType === "5" || postType === 5 ? " Event Post" :
                                 postType === "6" || postType === 6 ? " Announcement Post" : " Post"}</h4>
               </div>
            </div>
            <Card.Body>
               <div className="d-flex align-items-center">
                  <div className="user-img">
                     <img loading="lazy" src={profileData?.user_setting?.photo ? profileData?.user_setting?.photo :
                        "https://uzone360live.s3.amazonaws.com/noimage.png"} alt="userimg" className="avatar-60 rounded-circle" />
                  </div>
                  <form className="post-text ms-3 w-100 " onClick={handleShow}>
                     <input type="text" className="form-control rounded" placeholder="Write something here..." style={{ border: "none" }} />
                  </form>
               </div>
               <hr />
               <ul className=" post-opt-block d-flex list-inline m-0 p-0 flex-wrap">
                  <li className="bg-soft-primary rounded p-2 pointer d-flex align-items-center me-3 mb-md-0 mb-2"><img loading="lazy" src={small07} alt="icon" className="img-fluid me-2" /> Photo/Video</li>
                  <li className="bg-soft-primary rounded p-2 pointer d-flex align-items-center me-3 mb-md-0 mb-2"><img loading="lazy" src={small08} alt="icon" className="img-fluid me-2" /> Tag Friend</li>
                  <li className="bg-soft-primary rounded p-2 pointer d-flex align-items-center me-3"><img loading="lazy" src={small09} alt="icon" className="img-fluid me-2" /> Feeling/Activity</li>
                  <li className="bg-soft-primary rounded p-2 pointer text-center">
                     <div className="card-header-toolbar d-flex align-items-center">
                        <Dropdown>
                           <Dropdown.Toggle as={CustomToggle} id="post-option"  >
                              <span className="material-symbols-outlined">
                                 more_horiz
                              </span>
                           </Dropdown.Toggle>
                           <Dropdown.Menu className=" dropdown-menu-right" aria-labelledby="post-option" >
                              <Dropdown.Item onClick={handleShow} href="#" >Check in</Dropdown.Item>
                              <Dropdown.Item onClick={handleShow} href="#" >Live Video</Dropdown.Item>
                              <Dropdown.Item onClick={handleShow} href="#" >Gif</Dropdown.Item>
                              <Dropdown.Item onClick={handleShow} href="#" >Watch Party</Dropdown.Item>
                              <Dropdown.Item onClick={handleShow} href="#" >Play with Friend</Dropdown.Item>
                           </Dropdown.Menu>
                        </Dropdown>
                     </div>
                  </li>
               </ul>
            </Card.Body>
            </Card> */}
         <Modal show={createPostModalShow} onHide={handleClose} size="lg" centered className="cpm-modern-modal">
            <Modal.Header className="cpm-modern-header">
               <div className="cpm-modern-title-wrap">
                  <div className="cpm-modern-title-icon">
                     <i className="ri-edit-box-line"></i>
                  </div>
                  <div>
                     <h5 className="modal-title cpm-modern-title" id="post-modalLabel">Create {postLabel}</h5>
                     <div className="cpm-modern-subtitle">Write, attach, tag and publish in one flow</div>
                  </div>
               </div>
               <button type="button" className="cpm-modern-close" onClick={handleClose}>
                  <span className="material-symbols-outlined">close</span>
               </button>
            </Modal.Header>
            <Modal.Body className="cpm-modern-body">
               <div className="d-flex align-items-center cpm-modern-composer">
                  <div className="user-img">
                     <img style={{ height: 60, width: 60 }} loading="lazy" src={profileData?.user_setting?.photo ? profileData?.user_setting?.photo :
                        "https://uzone360live.s3.amazonaws.com/noimage.png"} alt="userimg" className="avatar-60 rounded-circle img-fluid" />
                  </div>
                  <div className="post-text ms-3 w-100">
                     <Form.Control
                        as="textarea"
                        rows={5}
                        className="form-control rounded cpm-modern-textarea"
                        placeholder="Write something here..."
                        value={postContent}
                        onChange={(e) => { setPostContent(e.target.value) }}
                     />
                  </div>
               </div>
               <div className="d-flex justify-content-end mt-2">
                  <Button
                     variant="primary"
                     className="ai-create-btn"
                     size="sm"
                     onClick={() => setShowAIContentModal(true)}
                     style={{ fontSize: '12px', fontWeight: '700' }}
                  >
                     {/* ri-magic-line was rendering as an unrelated gear glyph — this
                         self-hosted remixicon font file doesn't match the class list's
                         codepoints for every icon. material-symbols-outlined (already used
                         elsewhere in this app, e.g. this modal's own close button) renders
                         reliably via ligature name rather than a font-specific codepoint. */}
                     <span className="material-symbols-outlined">auto_awesome</span>
                     AI Creation
                  </Button>
               </div>
               {imageArray.length > 0 || videoThumbArray.length > 0 ?
                  <div className="row cpm-modern-preview mt-3">
                     <>
                        {
                           imageArray.map((elm, i) => (
                              <div key={elm + i} className="col-md-2 col-sm-6 col-6 col-lg-2 cpm-modern-preview-item">
                                 <img loading="lazy" src={elm}
                                    alt="gallary" className="img-fluid cpm-modern-preview-thumb" />
                                 <Link className="cpm-modern-preview-remove"
                                    onClick={() => {
                                       let tempImageFile = imageFileArray.slice();
                                       tempImageFile.splice(i, 1)
                                       setImageFileArray(tempImageFile);
                                       //setImageFileArray(imageFileArray.splice(i, 1))
                                       //setImageArray(imageArray.splice(i, 1))
                                       let tempImage = imageArray.slice();
                                       tempImage.splice(i, 1)
                                       setImageArray(tempImage);
                                    }}>
                                    {/* <i className="icon material-symbols-outlined">cancel</i> */}
                                    <img style={{ height: 25, width: 25 }} src={cross} />
                                 </Link>
                              </div>
                           ))
                        }
                        {
                           videoThumbArray.map((elm, i) => (
                              <div key={"key" + i} className="col-md-2 col-sm-6 col-6 col-lg-2 cpm-modern-preview-item" >
                                 <div className="img-fluid cpm-modern-preview-thumb-wrap">
                                    <img loading="lazy" src={videoThumbArray[i]}
                                       alt="gallary" className="img-fluid cpm-modern-preview-thumb" />
                                    {/* <VideoThumbnail
                                          width={70}
                                          height={70}
                                          videoUrl={elm} /> */}
                                 </div>

                                 <Link className="cpm-modern-preview-remove"
                                    onClick={() => {
                                       // videoThumbArray.splice(index, 1)
                                       // videoThumbFileArray.splice(index, 1)
                                       // videoFileArray.splice(index, 1)

                                       let tempVideoThumb = videoThumbArray.slice();
                                       tempVideoThumb.splice(i, 1)
                                       setVideoThumbArray(tempVideoThumb);

                                       let tempVideoThumbFile = videoThumbFileArray.slice();
                                       tempVideoThumbFile.splice(i, 1)
                                       setVideoThumbFileArray(tempVideoThumbFile);

                                       let tempVideoFile = videoFileArray.slice();
                                       tempVideoFile.splice(i, 1)
                                       setVideoFileArray(tempVideoFile);
                                    }}>
                                    <img style={{ height: 25, width: 25 }} src={cross} />
                                 </Link>
                                 <Link className="cpm-modern-preview-play">
                                    <img style={{ height: 25, width: 25 }} src={playButton} />
                                 </Link>
                              </div>
                           ))
                        }
                     </>
                  </div> : null
               }
               
               {/* Tagged Followers Display */}
               {taggedFriends.length > 0 && (
                  <div className="tagged-friends-display mb-3">
                     <div className="d-flex align-items-center flex-wrap">
                        <span className="me-2" style={{ fontWeight: 500, color: "#666" }}>
                           <i className="ri-user-add-line me-1"></i>
                           Tagged:
                        </span>
                        {taggedFriends.map((friend, index) => (
                           <div key={friend.id} className="tagged-friend-badge">
                              <img 
                                 src={friend.photo || "https://uzone360live.s3.amazonaws.com/noimage.png"} 
                                 alt={friend.first_name}
                              />
                              <Link 
                                 to={`/dashboard/app/friend-profile/${friend.slug}`}
                                 className="tagged-friend-badge-name"
                                 onClick={(e) => e.stopPropagation()}
                              >
                                 {friend.first_name} {friend.last_name}
                              </Link>
                              <span 
                                 className="tagged-friend-remove-btn"
                                 onClick={() => {
                                    const updatedFriends = taggedFriends.filter((_, i) => i !== index);
                                    setTaggedFriends(updatedFriends);
                                 }}
                              >
                                 ×
                              </span>
                           </div>
                        ))}
                     </div>
                  </div>
               )}
               
               {/* col-md-* on these li's only takes effect at md+ — below that they had no
                   width rule at all, so the label and the icon buttons wrapped wherever the
                   flex row ran out of space instead of as a deliberate group. Label on its
                   own line, icon buttons as one flex-wrap group with a real gap, at every
                   width. */}
               <h5 className="cpm-modern-tools-title mb-2">Add to your post</h5>
               <div className="d-flex flex-wrap align-items-center gap-2 mb-2 cpm-modern-tools">
                  <div className="d-flex justify-content-center bg-soft-primary rounded p-2 cursor-pointer cpm-modern-tool" >
                     {/* cursor-pointer added here too, not just on the wrapping
                         div - the label is what's actually under the cursor
                         when hovering the icon, and relying on it to inherit
                         cursor from an ancestor wasn't holding up in every
                         browser the way a plain onClick div (Tag Friend,
                         Emoji) does. Setting it directly is unambiguous. */}
                     <label htmlFor="imageUpload1" className="d-flex align-items-center justify-content-center m-0 cursor-pointer">
                        <i className="material-symbols-outlined md-18" aria-label="Attach image">image</i>
                     </label>
                     <input className="file-upload"
                        id="imageUpload1" type="file" accept="image/png, image/jpg, image/jpeg"
                        multiple="multiple"
                        onChange={handleImageChange} />
                  </div>
                  <div className="d-flex justify-content-center bg-soft-primary rounded p-2 cursor-pointer cpm-modern-tool">
                     <label htmlFor="videoUpload1" className="d-flex align-items-center justify-content-center m-0 cursor-pointer">
                        <i className="material-symbols-outlined md-18" aria-label="Attach video">videocam</i>
                     </label>
                     <input className="file-upload"
                        id="videoUpload1" type="file" accept="video/*"
                        multiple="multiple"
                        onChange={handleVideoChange} />
                  </div>
                  {(postType === 0 || postType === "0") && (
                     <div
                        className="d-flex justify-content-center bg-soft-primary rounded p-2 cursor-pointer cpm-modern-tool"
                        onClick={() => setShowTagFriendModal(true)}
                        title="Tag Followers"
                     >
                        <i className="material-symbols-outlined md-18" aria-label="Tag followers">person_add</i>
                     </div>
                  )}
                  <div className="d-flex justify-content-center bg-soft-primary rounded p-2 cursor-pointer cpm-modern-tool" onClick={() => setShowPicker((val) => !val)}>
                     <i className="material-symbols-outlined md-18" aria-label="Insert emoji">mood</i>
                  </div>
                  {/* <div className="bg-soft-primary rounded p-2 pointer"><Link to="#"></Link><img loading="lazy" src={small6} alt="icon" className="img-fluid" /></div> */}
               </div>
               {showPicker ?
                  <EmojiPicker pickerStyle={{ width: "100%" }} onEmojiClick={(emojiObject) => setPostContent((prevMsg) => prevMsg + emojiObject.emoji)} /> : null
               }
               {
                  postType === "2" || postType === 2 || postType === "3" || postType === 3 ?
                     <div>
                        <hr />
                        <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0">
                           <li className="col-md-7 mb-1">
                              <h5>Select Expiry Date</h5>
                           </li>
                           <li className="col-md-5 mb-1">
                              <Form.Group className="form-group">
                                 <Form.Control type="date" className="mb-0" id="dob" placeholder="Date of Birth"
                                    min={new Date().toISOString().split("T")[0]}
                                    //defaultValue={setDOB(date_variable)}
                                    value={challengeExpireDate} onChange={(e) => setChallengeExpireDate(e.target.value)} />
                              </Form.Group>
                           </li>
                        </ul>
                     </div> : null
               }

               <hr />
               <Button variant="primary" className="d-block w-100 mt-3 cpm-modern-submit"
                  onClick={() => {
                     handlePostSubmit()
                  }}>
                  <i className="ri-send-plane-fill me-2"></i>
                  Create {postLabel}
               </Button>
            </Modal.Body>
         </Modal>
         
         {/* Tag Followers Modal */}
         <TagFriendSelector
            show={showTagFriendModal}
            onHide={() => setShowTagFriendModal(false)}
            onSelectFriends={(friends) => setTaggedFriends(friends)}
            selectedFriends={taggedFriends}
         />

         <AIContentCreatorModal
            show={showAIContentModal}
            onHide={() => setShowAIContentModal(false)}
            onApply={(content) => setPostContent(content)}
            title="AI Post Content"
            targetLabel="feed post"
            defaultKeywords={postContent}
         />

      </>
   )
}

export default CreatePostModal
